import React from 'react';
import { getRetryError } from '../util';
import { type OrganismState, errors } from '../types';
import { ErrorScreen } from '@/molecules';

export type DisplayErrorProps = {
  organismState: OrganismState;
  dispatch: Parameters<typeof getRetryError>[1];
  onErrorClick: React.MouseEventHandler;
};

export function DisplayError({ organismState, dispatch, onErrorClick }: DisplayErrorProps) {
  let error = null;
  const [actionLabel, action] = getRetryError(organismState, dispatch, onErrorClick);
  switch (organismState.error) {
    case errors.ACCOUNT_TIMEOUT:
    case errors.ACCOUNT_ERROR:
    case errors.FEED_ERROR:
      console.error('There was an error getting account details or feed items');
      error = (
        <ErrorScreen
          body="We could not update your feed"
          icon="close"
          title="Can't update feed"
          actionLabel={actionLabel}
          action={action}
        />
      );
      break;
    default:
      console.error('There was an error, showing catchall message', organismState.error);
      error = (
        <ErrorScreen
          body="There was an error"
          icon="close"
          title="Error"
          actionLabel={actionLabel}
          action={action}
        />
      );
      break;
  }

  return <div className="error-container">{error}</div>;
}
